import { getDefaultWebContext } from "VSS/Context";
import { WebPageDataService } from "VSS/Contributions/Services";
import { publishErrorToTelemetry } from "VSS/Error";
import { getService } from "VSS/Service";
import {
    ExternalLinkedArtifact,
    ExternalLinkedArtifactIdentifier,
    GitHubLinkItemsRequest,
    GitHubLinkItemsResponse
} from "TFS/WorkItemTracking/DataProviderContracts";

const GitHubLinkDataProvider = "ms.vss-work-web.github-link-data-provider";

async function _getGitHubLinkData(
    properties: { urls: string[] } | { identifiers: ExternalLinkedArtifactIdentifier[] },
    workItemId: number | null
): Promise<ExternalLinkedArtifact[]> {
    try {
        const gitHubLinkItemsRequest: GitHubLinkItemsRequest = {
            ...properties,
            workItemId: workItemId
        } as GitHubLinkItemsRequest;
        const gitHubLinkItemsResponse: GitHubLinkItemsResponse = await getService(WebPageDataService, getDefaultWebContext()).getDataAsync<
            GitHubLinkItemsResponse,
            GitHubLinkItemsRequest
        >(GitHubLinkDataProvider, null, gitHubLinkItemsRequest);
        return gitHubLinkItemsResponse && gitHubLinkItemsResponse.resolvedLinkItems && gitHubLinkItemsResponse.resolvedLinkItems.length > 0
            ? gitHubLinkItemsResponse.resolvedLinkItems
            : [];
    } catch (ex) {
        publishErrorToTelemetry(ex);
        return [];
    }
}

export function resolveGitHubUrls(urls: string[], workItemId: number | null): Promise<ExternalLinkedArtifact[]> {
    const properties = { urls: urls };
    return _getGitHubLinkData(properties, workItemId);
}

export function resolveGitHubItems(
    itemIdentifiers: ExternalLinkedArtifactIdentifier[],
    workItemId: number | null
): Promise<ExternalLinkedArtifact[]> {
    const properties = { identifiers: itemIdentifiers };
    return _getGitHubLinkData(properties, workItemId);
}
